module.exports = __webpack_public_path__ + "img/cart.b91b4d51.svg";